export default "__VITE_ASSET___l9MdHbW__"